import styled from 'styled-components';
import { rem } from 'polished';
import Button from '@atoms/Button/Button';

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${rem(16)}};
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${rem(20)};
  align-items: center;
  margin-top: ${rem(40)};
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;
